import React from 'react';

import {MainHeader} from 'presentation/components/MainHeader';
import {PageWrapperLayout} from 'presentation/components/PageWrapperLayout';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {SubHeader} from '../../components';
import {useAuthorizations} from '../../hooks';
import {AuthorizationsOdontoList} from './AuthorizationsOdontoList';

const {titleOdonto} = translations['pt-br'].privateFlow.requestAuthorizations;

export function AuthorizationsOdonto() {
	const {isTablet} = useMediaQueries();
	const {handleBack, handleChangeBeneficiary} = useAuthorizations();

	return (
		<PageWrapperLayout title={titleOdonto}>
			<MainHeader
				title={titleOdonto}
				handleBack={handleBack}
				handleClose={handleBack}
				variant="subRoute">
				{isTablet ? <SubHeader handleAction={handleChangeBeneficiary} /> : null}
			</MainHeader>
			<AuthorizationsOdontoList />
		</PageWrapperLayout>
	);
}
